import { NodeGlyph } from "./NodeVisuals";
import type { WorkflowNode } from "../model";

export function NodeInspector({
  selectedNode,
  upstreamNodes,
}: {
  selectedNode: WorkflowNode | null;
  upstreamNodes: WorkflowNode[];
}) {
  return (
    <>
      <div className="inspector-card">
        {selectedNode ? (
          <div className="inspector-heading">
            <div
              className={`inspector-icon inspector-icon--${selectedNode.category}`}
            >
              <NodeGlyph category={selectedNode.category} />
            </div>
            <div>
              <p className="inspector-title">{selectedNode.title}</p>
              <p className="inspector-subtitle">{selectedNode.subtitle}</p>
            </div>
          </div>
        ) : (
          <p className="inspector-empty">
            Select a node to inspect its settings.
          </p>
        )}
        {selectedNode && (
          <dl className="inspector-list">
            <div className="inspector-row">
              <dt>Category</dt>
              <dd>{selectedNode.category}</dd>
            </div>
            <div className="inspector-row">
              <dt>Input</dt>
              <dd>{selectedNode.input}</dd>
            </div>
            <div className="inspector-row">
              <dt>Output</dt>
              <dd>{selectedNode.output}</dd>
            </div>
          </dl>
        )}
        {selectedNode && Object.entries(selectedNode.properties).length > 0 && (
          <div className="inspector-properties">
            <p className="inspector-properties-title">Output properties</p>
            {Object.entries(selectedNode.properties).map(([key, value]) => (
              <div className="inspector-property" key={key}>
                <span>{key}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>
        )}
        {upstreamNodes.length > 0 && (
          <div className="inspector-properties">
            <p className="inspector-properties-title">
              Available from previous node
            </p>
            {upstreamNodes.flatMap((node) =>
              Object.entries(node.properties).map(([key, value]) => (
                <div className="inspector-property" key={`${node.id}-${key}`}>
                  <span>
                    {node.title} · {key}
                  </span>
                  <strong>{value}</strong>
                </div>
              )),
            )}
          </div>
        )}
      </div>
    </>
  );
}
